// extracted by mini-css-extract-plugin
export default {"container":"MatchEvents_container__jzvFo","name":"MatchEvents_name__pZmea","time":"MatchEvents_time__g0AGa"};